.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--min-col, 320px), 1fr));
  gap: var(--space-lg);
}

.item {
  animation: fadeInUp var(--transition-slow) ease both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.item:nth-child(1) { animation-delay: 0ms; }
.item:nth-child(2) { animation-delay: 50ms; }
.item:nth-child(3) { animation-delay: 100ms; }
.item:nth-child(4) { animation-delay: 150ms; }
.item:nth-child(5) { animation-delay: 200ms; }
.item:nth-child(6) { animation-delay: 250ms; }

@media (prefers-reduced-motion: reduce) {
  .item {
    animation: none;
  }
}
